import { Injectable } from "@angular/core";

//Class used to format things in the system
@Injectable({
    providedIn: 'root'
})
export class FormatHelperService {
    static GetIsNully = (input: any): boolean => input === undefined || input === null;
    static GetIsNullyOrWhitespace = (value: string): boolean => FormatHelperService.GetIsNully(value) || value.replace(/\s/g, '') === '';
    static toCamelCase = (input: string): string => FormatHelperService.GetIsNullyOrWhitespace(input) ? '' 
        : `${input[0].toLowerCase()}${FormatHelperService.toTitleCase(input).slice(1)}`;
    static toTitleCase = (input: string): string => FormatHelperService.GetIsNullyOrWhitespace(input) ? '' 
        : input.split(/[^a-zA-Z]+/g).map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join('');

    toCamelCase = (input: string): string => FormatHelperService.toCamelCase(input);
    toTitleCase = (input: string): string => FormatHelperService.toTitleCase(input);
    FormatNdc = (ndc: string): string => ndc.replace(/(\d{5})(\d{4})(\d{2})/, '$1-$2-$3');
    GetIsNully = (value: any): boolean => value === undefined || value === null;
    GetIsNullyOrWhitespace = (value: string): boolean => this.GetIsNully(value) || value.replace(/\s/g, '') === '';
}
